const supabaseConfig = {}
export default supabaseConfig
